import { useCallback, useEffect, useState } from 'react'

import app from 'common/builder/components/chart/FlowChart/app'

export const useFlowChartAppState = (): [string, { srcId: string }] => {
  const [srcId, setSrcId] = useState('')
  const [state, setState] = useState('')

  const handleStateChange = useCallback((state: string) => {
    // eslint-disable-next-line
    // @ts-expect-error
    setSrcId(app.stateOptions?.src ?? '')
    setState(state)
  }, [])

  useEffect(() => {
    app.on('state', handleStateChange)
    return () => {
      app.removeListener('state', handleStateChange)
    }
  }, [handleStateChange])

  return [state, { srcId }]
}
